import { getAxiosClient } from '~src/api';

/**
 * Checks for saved payment methods
 * @returns {Promise<Object>} Result with success and hasPaymentMethods flags
 */
const checkPaymentMethods = async () => {
  try {
    const httpClient = await getAxiosClient();
    const response = await httpClient({
      url: `${process.env.USER_API_URL}/stripe/payment-methods`,
      method: 'GET',
    });

    return response.data;
  } catch (error) {
    console.error('Error checking payment methods:', error);
    return { success: false };
  }
};

export default checkPaymentMethods;
